import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=ea223298&scoped=true&"
import script from "./TicketList.vue?vue&type=script&lang=js&"
export * from "./TicketList.vue?vue&type=script&lang=js&"
import style0 from "./TicketList.vue?vue&type=style&index=0&id=ea223298&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea223298",
  null
  
)

export default component.exports